import { jsx } from 'react/jsx-runtime';
import classnames from '../../node_modules/classnames/index.js';
import modules_ccac1dec from './Spinner.module.scss.js';

const Spinner = ({ className, appearance = "default", "data-testid": testId, size = "16px", }) => {
    const svgSize = typeof size === "string" ? size : `${size}px`;
    return (jsx("div", { "data-testid": testId, className: classnames(modules_ccac1dec.wrapper, className), children: jsx("svg", { className: modules_ccac1dec.svg, width: svgSize, height: svgSize, viewBox: "0 0 150 150", children: jsx("circle", { r: "60", cx: "75", cy: "75", fill: "none", strokeWidth: 12, strokeDasharray: 300, strokeDashoffset: 600, strokeMiterlimit: 10, strokeLinecap: "round", className: classnames(modules_ccac1dec.line, modules_ccac1dec[appearance]) }) }) }));
};

export { Spinner };
//# sourceMappingURL=Spinner.js.map
